import {z} from 'zod';

export const userSearchSchema = z.object({
    searchTerm: z.string().optional(),
    pageSize: z.number().catch(50),
    page: z.number().catch(1),
});